var React = require('react');

function Plus (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M31 0L29 0V29H0L0 31H29L29 60H31L31 31L60 31V29L31 29V0Z","fill":"white"}));
}

Plus.defaultProps = {"width":"60","height":"60","viewBox":"0 0 60 60","fill":"none"};

module.exports = Plus;

Plus.default = Plus;
